import { createContext, FC } from 'react';

export type ServerVarsContextType = {
    isDesktop?: boolean | null;
    isMobile?: boolean | null;
    isSbAdsEnabled?: boolean | null;
    isTablet?: boolean | null;
    clientConf?: { [key: string]: string | number | undefined } | null;
    localeOrigin?: string | null;
    isSearchQueryApplied?: boolean | null;
    isSmallerSbCategoryTilesVariant?: boolean | null;
    isSbTopNavVariant?: boolean | null;
    isPdpMetaDescRemovalVariant?: boolean | null;
    isRelatedSearchesVariant?: boolean | null;
    buyPageMetaTitleTestGroup?: string | null;
    locale?: string | null;
    isSbUsabilityUpdatesVariant?: boolean | null;
    isMobilePdpRedesign?: boolean | null;
    isSoldPdpRedesign?: boolean | null;
};

export const ServerVarsContext = createContext<ServerVarsContextType>({
    isDesktop: null,
    isMobile: null,
    isSbAdsEnabled: null,
    isTablet: null,
    clientConf: {},
    localeOrigin: null,
    locale: null,
    isSearchQueryApplied: null,
    isSmallerSbCategoryTilesVariant: null,
    isSbTopNavVariant: null,
    isPdpMetaDescRemovalVariant: null,
    isRelatedSearchesVariant: null,
    buyPageMetaTitleTestGroup: null,
    isSbUsabilityUpdatesVariant: null,
    isMobilePdpRedesign: null,
    isSoldPdpRedesign: null,
});

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export const ServerVarsContextProvider: FC<ServerVarsContextType> = ({
    children,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
    localeOrigin,
    isSearchQueryApplied,
    isSmallerSbCategoryTilesVariant,
    isSbTopNavVariant,
    isPdpMetaDescRemovalVariant,
    isRelatedSearchesVariant,
    buyPageMetaTitleTestGroup,
    isSbUsabilityUpdatesVariant,
    locale,
    isMobilePdpRedesign,
    isSoldPdpRedesign,
}) => {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
                localeOrigin,
                isSearchQueryApplied,
                isSmallerSbCategoryTilesVariant,
                isSbTopNavVariant,
                isPdpMetaDescRemovalVariant,
                isRelatedSearchesVariant,
                buyPageMetaTitleTestGroup,
                isSbUsabilityUpdatesVariant,
                locale,
                isMobilePdpRedesign,
                isSoldPdpRedesign,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
};
